import { Component, Input, OnInit } from "@angular/core";
import { AgreementsService } from "../../../../shared/services/agreements.service";
import { AgreementPriceDto } from "../../../../shared/models/agreement/agreement-price.dto";
import { AgreementPriceService } from "../../services/agreement-price-service";

@Component({
    selector: 'agreement-price',
    templateUrl: './agreement-price.component.html',
    styleUrls: [
        './agreement-price.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementPriceComponent implements OnInit {
    
    @Input() agreementId: number;

    agreementPrice: AgreementPriceDto;
    loading: boolean = false;

    constructor(
        private agreementsService: AgreementsService,
        private agreementPriceService: AgreementPriceService
    ) { }

    ngOnInit(): void {
        this.agreementPriceService.priceChange$.subscribe(() => this.loadAgreementPrice());
        this.loadAgreementPrice();
    }

    loadAgreementPrice() {
        this.loading = true;
        this.agreementsService.getAgreentPrice(this.agreementId).subscribe(resp => {
            this.agreementPrice = resp;
            this.loading = false;
        }, () => this.loading = false);
    }
}